import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';

import { Product } from '../../product.model';

import * as productActions from '../actions/products.actions';
import { ActionType } from '../actions/products.actions';


export interface State extends EntityState<Product> { fetchRunning: null; addProductStatus: { status: null, id: null }; }

export const productAdapter: EntityAdapter<Product> = createEntityAdapter<Product>();

export const initialState: State = productAdapter.getInitialState({ fetchRunning: null, addProductStatus: { status: null, id: null } });

export function productReducer(
  state: State = initialState,
  action: productActions.ProductActions
) {
  switch (action.type) {

    case ActionType.FETCH_PRODUCTS_BY_COMPANYIDSITEID_SUCCESS:
      return productAdapter.setAll(action.products, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_PRODUCTS_BY_COMPANYID_SUCCESS:
      return productAdapter.setAll(action.products, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_PRODUCTS_SUCCESS:
      return productAdapter.setAll(action.products, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.ADD_PRODUCT:
      return {
        ...state,
        fetchRunning: true,
        addProductStatus: { status: false, ids: null }
      };
    case ActionType.ADD_PRODUCT_SUCCESS:
      return productAdapter.addOne(action.product, {
        ...state,
        fetchRunning: false,
        addProductStatus: { status: true, id: action.product.id }
      });

    case ActionType.ADD_PRODUCT_FAILED:
      return {
        ...state,
        fetchRunning: false,
        addProductStatus: { status: false, id: null }
      };

    case ActionType.DELETE_PRODUCT:
      return {
        ...state,
        fetchRunning: true,
      };
    // case ActionType.DELETE_PRODUCT_SUCCESS:
    //   return productAdapter.removeOne(action.id, {
    //     ...state,
    //     fetchRunning: false,
    //   });

    case ActionType.DELETE_PRODUCT_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_PRODUCT:
      return {
        ...state,
        fetchRunning: true,
      };
    case ActionType.UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_PRODUCT_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };



    //  return productAdapter.addOne(action.payload.product, state);
    // case productActions.TOGGLE_DONE:
    //   return productAdapter.updateOne(
    //     { id: action.payload.id, changes: { done: action.payload.done } },
    //     state
    //   );
    // case productActions.UPDATE_PRODUCT:
    //   return productAdapter.updateOne(
    //     { id: action.payload.id, changes: { value: action.payload.newValue } },
    //     state
    //   );
    // case productActions.DELETE_PRODUCT:
    // return productAdapter.removeOne(action.payload.id, state);



    default:
      return state;
  }
}

export const getFetchRunning = (state: State) => state.fetchRunning;
export const getProductStatus = (state: State) => state.addProductStatus;
